// Kaskádové listboxy pro výběr skupiny v collapsed InfoPanelu (viz doc/plans/infopanel-group-listboxes.md)
// Alternativa ke stromu GroupTree na záložce "Skupina" — řídí stejný selectedPath state.
const UNSELECTED = '__unselected__'

export function GroupPathSelects({ groupLevels, filteredTree, selectedPath, setSelectedPath, savedGroups, editingSavedGroupId, onSelectSavedGroup }) {
  const savedGroupSelect = savedGroups.length > 0 && (
    <select
      className="w-full border border-gray-200 rounded-lg px-2 py-1 text-xs"
      value={editingSavedGroupId ?? ''}
      onChange={e => onSelectSavedGroup(e.target.value)}
    >
      <option value="">— vlastní výběr —</option>
      {savedGroups.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
    </select>
  )

  if (groupLevels.length === 0) {
    if (!savedGroupSelect) return null
    return <div className="px-3 py-2 border-b border-gray-100">{savedGroupSelect}</div>
  }

  // Sestav řetězec listboxů: pro každou úroveň i vezmi uzly na téhle úrovni (nodesAtLevel) a
  // aktuálně vybraný label (selectedPath[i]); pokračuj do další úrovně, jen pokud je něco vybráno
  // a vybraný uzel má děti.
  const levels = []
  let nodesAtLevel = filteredTree
  for (let i = 0; nodesAtLevel.length > 0; i++) {
    const selectedLabel = selectedPath[i]?.bucketLabel ?? UNSELECTED
    const selectedNode = nodesAtLevel.find(n => n.label === selectedLabel) ?? null
    levels.push({ depth: i, nodes: nodesAtLevel, selectedLabel })
    if (!selectedNode || selectedNode.children.length === 0) break
    nodesAtLevel = selectedNode.children
  }

  return (
    <div className="px-3 py-2 border-b border-gray-100 flex flex-col gap-1">
      {savedGroupSelect}
      {levels.map(({ depth, nodes, selectedLabel }) => (
        <select
          key={depth}
          className="w-full border border-gray-200 rounded-lg px-2 py-1 text-xs"
          value={selectedLabel}
          onChange={e => {
            const value = e.target.value
            if (value === UNSELECTED) {
              setSelectedPath(selectedPath.slice(0, depth))
            } else {
              setSelectedPath([...selectedPath.slice(0, depth), { bucketLabel: value }])
            }
          }}
        >
          <option value={UNSELECTED}>— nevybráno —</option>
          {nodes.map(n => <option key={n.label} value={n.label}>{n.label}</option>)}
        </select>
      ))}
    </div>
  )
}
